// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1iUn-","colBig":"styles_colBig__2V-SO","colSmall":"styles_colSmall__2tuC5","shopifyNameWrapper":"styles_shopifyNameWrapper__1y19T"};